import { useMsal } from '@azure/msal-react'
import { LogoutOutlined } from '@ant-design/icons'
import { globalConfig } from '../../../configuration/config'
import { API_URLs } from '../../../configuration/api-urls'
import { ActivityTypes, decryptIdToken } from '../../../pages/constants'
import { useEffect, useState } from 'react'

export const SignOutButton = () => {
  const [idToken, setIdToken] = useState<string | null>(null)

  useEffect(() => {
    const fetchDecryptedToken = async () => {
      const decryptedToken = await decryptIdToken();
      setIdToken(decryptedToken);
    };

    fetchDecryptedToken();
  }, []);
  
  const { instance } = useMsal()
  const postPeerActivityUrl = globalConfig
    .get()
    .apiBaseUrl.concat(API_URLs.v1.POST_PeerSupporterActivity)

  function handleLogout(instance: any) {
    postLogoutActivity()
    instance.logoutRedirect().catch((e: any) => {
      console.error(e)
    })
  }

  const postLogoutActivity = () => {
    fetch(postPeerActivityUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ activityType: ActivityTypes.LOGOUT }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .catch((error) => {
        console.log('Unable to fetch notifications - ', error)
      })
  }

  return (
    <div
      className="flex flex-row justify-start items-center text-start gap-2 m-2"
      onClick={() => {
        handleLogout(instance)
      }}
      key={'logout'}
    >
      <LogoutOutlined className="stroke-2" />
      <div className="text-start text-sm font-barlow">Log out</div>
    </div>
  )
}
